<template>
  <div class="container">
    <div class="footer-top flex flex-x-center">
      <div class="footer-info flex space-between">
        <div class="footer-info-box">
          <span class="footer-title">
            网站导航
          </span>
          <ul class="footer-nav flex space-between">
            <li class="curPointer flex flex-column">
              <span class="curPointer" @click="handleJump('/')">首页</span>
              <span class="curPointer" @click="handleJump('/hotDynamic')">热点动态</span> 
              <span class="curPointer" @click="handleJump('/expertsLibrary')">专家智库</span>
            </li>
            <li class="curPointer flex flex-column">
              <span class="curPointer" @click="handleJump('/businessCollege')">商学院</span>
              <span class="curPointer" @click="handleJump('/studentCollege')">小院士</span>
              <span class="curPointer" @click="handleJump('/adultEducation')">职业技术培训</span>
            </li>
          </ul>
        </div>
        <div class="footer-info-box">
          <span class="footer-title">
            官方服务热线
          </span>
          <div class="footer-tel flex flex-y-center">
            <img src="../assets/images/home-8.png">
            <span>19913874360</span>
          </div>
          <p class="footer-desc">邮箱：daheshangxueyuan1@163.com</p>
          <p class="footer-desc">地址：河南省郑州市农业路经三路交叉口东南角银丰商务B座</p>
        </div>
        <div class="scan-code flex flex-column flex-y-center flex-x-center">
          <img src="../assets/images/dh-code.jpg">
          <span>微信公众号</span>
        </div>
      </div>
    </div>
    <div class="footer-bottom flex flex-y-center flex-x-center">
      <span>Copyright © 2017-2020, 豫ICP备16009299号-1 全网品牌推广：网总管       豫公网安备 41010502004723号</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerCom',
  data () {
    return {
      currentPath:'',//当前路由
    }
  },
  watch:{
    $route(to,from){
      this.currentPath = to.path
    }
  },
  methods:{
    handleJump(path){
      if(this.currentPath == path) return
      this.$router.push({path:path})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@media screen and (max-width: 1600px ) and (min-width:1200px) {
  .container{
    .footer-top{
      .footer-info{
        min-width:1200px !important;
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .footer-info{
    min-width:1000px !important;
  }
}
.container{
  width: 100%;
  height: auto;
  .footer-top{
    width: 100%;
    height: 354px;
    background-color: #373737;
    .footer-info{
      min-width:1400px;
      padding-top: 74px;
      .footer-info-box{
        .footer-title{
          display: block;
          font-size: 18px;
          color: #ffffff;
          font-weight: bold;
          position: relative;
          margin-bottom: 40px;
          &::after{
            position: absolute;
            content: "";
            width: 16px;
            height: 4px;
            background-color: #FF5A00;
            top: -20px;
            left: 0;
          }
        }
        .footer-nav{
          width: 210px;
          li{
            text-align: left;
            span{
              padding-bottom: 34px;
              color: #999;
              font-size: 14px;
            }
          }
        }
        .footer-tel{
          img{
            width: 50px;
            height: 50px;
            margin-right: 10px;
          }
          span{
            font-size: 42px;
            color: #ffffff;
            font-weight: bold;
          }
        }
        .footer-desc{
          font-size: 14px;
          color: #999;
          margin-top: 30px;
        }
      }
      .scan-code{
        width: 176px;
        height: 207px;
        background-color: #ffffff;
        img{
          width: 144px;
          height: 144px;
          margin-bottom: 16px;
        }
        span{
          font-size: 16px;
          color: #373737
        }
      }
    }
  }
  .footer-bottom{
    width: 100%;
    height: 65px;
    background-color: #262626;
    span{
      font-size: 14px;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footerCom.vue